import { Machine } from 'xstate';
import MODE from '../modes';
import workflows from './workflows/workflows';

const configureMachine = (state, { config, mode } = { mode: MODE.MAIN }) => {
  const machineConfig = config || workflows[mode] || workflows[MODE.MAIN];
  return Machine({
    ...machineConfig,
    initial: machineConfig.computeInitialState ? machineConfig.computeInitialState(state) : machineConfig.initial,
  });
};
export default configureMachine;
